import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@mui/material';
import {
  AddRounded as AddRoundedIcon,
  CloudUploadRounded as CloudUploadRoundedIcon,
  InsertLinkRounded as InsertLinkRoundedIcon,
} from '@mui/icons-material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { PROJECT_OPTIONS_INPUT_NEW } from '@src/constants/upload';
import { StyledCreateAudioMenu } from './index.style';

// Same three options the projects page offers behind its "Tạo audio" card, read
// from the same constant so the two menus cannot drift apart.
const CREATE_AUDIO_OPTIONS = PROJECT_OPTIONS_INPUT_NEW[0].subOptions || [];

const ICONS = {
  CreateProjectIcon: AddRoundedIcon,
  UploadFileIcon: CloudUploadRoundedIcon,
  WebLinkIcon: InsertLinkRoundedIcon,
};

const CreateAudioMenu = ({ anchorEl, onClose, onSelect }) => {
  const { t } = useTranslation();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        sx: {
          marginTop: '8px',
          borderRadius: '8px',
          boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08) !important',
        },
      }}
    >
      <StyledCreateAudioMenu>
        {CREATE_AUDIO_OPTIONS.map((option) => {
          const Icon = ICONS[option.icon];
          return (
            <button
              type="button"
              key={option.label}
              className="create-audio-item"
              onClick={() => onSelect(option)}
            >
              {Icon && <Icon sx={{ color: COLOR.navyBlue }} />}
              <Typography
                variant="body-14-medium"
                color={COLOR.descriptionGray}
              >
                {t(option.label)}
              </Typography>
            </button>
          );
        })}
      </StyledCreateAudioMenu>
    </Popover>
  );
};

export default CreateAudioMenu;
